import { render, staticRenderFns } from "./TextureForm.vue?vue&type=template&id=2d6c0f5d&"
import script from "./TextureForm.vue?vue&type=script&lang=js&"
export * from "./TextureForm.vue?vue&type=script&lang=js&"
import style0 from "./TextureForm.vue?vue&type=style&index=0&id=2d6c0f5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports